export default __webpack_public_path__ + "static/slidein-00aa3661b2fd42cbae27d51ab8b7b658.png";